"use client";
import React, { useState } from "react";
import { MobileHeader } from "../MobileHeader";
import { TabBar } from "../TabBar";
import { Link } from "react-router-dom";

const ProfileScreen: React.FC = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [profileData, setProfileData] = useState({
    firstName: "Sarah",
    lastName: "Johnson",
    email: "sarah.johnson@example.com",
    phone: "+27 71 234 5678",
    address: "123 Main Street, Green Point, Cape Town",
    postalCode: "8001",
  });
  
  const [formData, setFormData] = useState({...profileData});
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSave = () => {
    setProfileData({...formData});
    setIsEditing(false);
  };
  
  const handleCancel = () => {
    setFormData({...profileData});
    setIsEditing(false);
  };
  
  return (
    <main className="pb-72 mx-auto w-full max-w-[480px]">
      <div className="overflow-hidden w-full bg-white">
        <MobileHeader />
        <section className="pt-8 pb-12 w-full">
          <header className="w-full text-2xl font-semibold leading-none text-gray-900">
            <div className="px-4 w-full">
              <div className="w-full">
                <div className="flex flex-col justify-center w-full">
                  <h1 className="w-full">
                    Profile
                  </h1>
                </div>
              </div>
            </div>
          </header>

          <section className="mt-8 w-full">
            <div className="px-4 w-full">
              {/* Profile Avatar */}
              <div className="flex flex-col items-center mb-8">
                <div className="relative">
                  <div className="w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center overflow-hidden border-4 border-white shadow-md">
                    <div className="text-3xl font-bold text-blue-500">
                      {profileData.firstName.charAt(0)}{profileData.lastName.charAt(0)}
                    </div>
                  </div>
                  {!isEditing && (
                    <button className="absolute bottom-0 right-0 bg-blue-500 text-white p-2 rounded-full shadow-md">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 16L16 12L12 8M8 12H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                  )}
                </div>
                <h2 className="mt-4 text-lg font-semibold text-gray-900">{profileData.firstName} {profileData.lastName}</h2>
                <p className="text-sm text-gray-500">Customer since January 2023</p>
              </div>
              
              {/* Profile Information */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm mb-6">
                <div className="p-4 border-b border-gray-200">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-base font-semibold text-gray-900">Personal Information</h3>
                    {!isEditing && (
                      <button 
                        onClick={() => setIsEditing(true)}
                        className="text-sm font-medium text-blue-600 flex items-center gap-1"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11 4H4V20H20V13M18.5 2.5L21.5 5.5L12 15L8 16L9 12L18.5 2.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        Edit
                      </button>
                    )}
                  </div>
                  
                  {isEditing ? (
                    <form className="space-y-4">
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                          <input 
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                          <input 
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                          />
                        </div>
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                        <input 
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                        <input 
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
                        <input 
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleInputChange}
                          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Postal Code</label>
                        <input 
                          type="text"
                          name="postalCode"
                          value={formData.postalCode}
                          onChange={handleInputChange}
                          className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                      
                      <div className="flex gap-4">
                        <button 
                          type="button"
                          onClick={handleSave}
                          className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors flex-1"
                        >
                          Save Changes
                        </button>
                        <button 
                          type="button"
                          onClick={handleCancel}
                          className="bg-gray-200 text-gray-800 py-2 px-4 rounded-md hover:bg-gray-300 transition-colors flex-1"
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  ) : (
                    <div className="space-y-4">
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <p className="text-xs text-gray-500">First Name</p>
                          <p className="text-sm font-medium text-gray-900">{profileData.firstName}</p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500">Last Name</p>
                          <p className="text-sm font-medium text-gray-900">{profileData.lastName}</p>
                        </div>
                      </div>
                      
                      <div>
                        <p className="text-xs text-gray-500">Email</p>
                        <p className="text-sm font-medium text-gray-900">{profileData.email}</p>
                      </div>
                      
                      <div>
                        <p className="text-xs text-gray-500">Phone Number</p>
                        <p className="text-sm font-medium text-gray-900">{profileData.phone}</p>
                      </div>
                      
                      <div>
                        <p className="text-xs text-gray-500">Address</p>
                        <p className="text-sm font-medium text-gray-900">{profileData.address}</p>
                      </div>
                      
                      <div>
                        <p className="text-xs text-gray-500">Postal Code</p>
                        <p className="text-sm font-medium text-gray-900">{profileData.postalCode}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Account Information */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm mb-6">
                <div className="p-4 border-b border-gray-200">
                  <h3 className="text-base font-semibold text-gray-900 mb-4">Account Information</h3>
                  
                  <div className="space-y-4">
                    <div>
                      <p className="text-xs text-gray-500">Account Number</p>
                      <p className="text-sm font-medium text-gray-900">CT-78562901</p>
                    </div>
                    
                    <div>
                      <p className="text-xs text-gray-500">Current Water Plan</p>
                      <div className="flex justify-between items-center">
                        <p className="text-sm font-medium text-gray-900">Standard Plan (18,000L)</p>
                        <Link
                          to="/change-plan"
                          className="text-xs font-medium text-blue-600 py-1 px-2 bg-blue-50 rounded-md"
                        >
                          Change Plan
                        </Link>
                      </div>
                    </div>
                    
                    <div>
                      <p className="text-xs text-gray-500">Billing Cycle</p>
                      <p className="text-sm font-medium text-gray-900">Monthly (1st of each month)</p>
                    </div>
                    
                    <div>
                      <p className="text-xs text-gray-500">Payment Method</p>
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                          <div className="w-8 h-5 bg-blue-100 rounded flex items-center justify-center">
                            <span className="text-xs font-bold text-blue-800">VISA</span>
                          </div>
                          <p className="text-sm font-medium text-gray-900">•••• 1234</p>
                        </div>
                        <Link
                          to="/make-payment"
                          className="text-xs font-medium text-blue-600 py-1 px-2 bg-blue-50 rounded-md"
                        >
                          Update
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Usage Statistics */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm mb-6">
                <div className="p-4">
                  <h3 className="text-base font-semibold text-gray-900 mb-4">Usage Statistics</h3>
                  
                  <div className="space-y-4">
                    <div>
                      <p className="text-xs text-gray-500">Current Month Usage</p>
                      <div className="flex items-end gap-2">
                        <p className="text-lg font-semibold text-gray-900">14,280L</p>
                        <p className="text-xs text-green-600 pb-1">79% of allocation</p>
                      </div>
                      <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden">
                        <div className="h-2 bg-blue-600 rounded-full" style={{ width: '79%' }}></div>
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <p className="text-xs text-gray-500">Average Daily</p>
                        <p className="text-sm font-medium text-gray-900">476L</p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Peak Day</p>
                        <p className="text-sm font-medium text-gray-900">625L (Apr 3)</p>
                      </div>
                    </div>
                    
                    <Link
                      to="/usage"
                      className="block text-center text-sm font-medium text-blue-600 py-2"
                    >
                      View Detailed Usage
                    </Link>
                  </div>
                </div>
              </div>
              
              {/* Delete Account */}
              <button className="w-full py-3 mt-4 text-sm font-medium text-red-600 bg-white rounded-lg border border-red-200 shadow-sm hover:bg-red-50 transition-colors">
                Delete Account
              </button>
            </div>
          </section>
        </section>
      </div>

      <TabBar />
    </main>
  );
};

export default ProfileScreen;
